import UserListComponent from '@/components/chat/_components/user-list';
import MessageListComponent from '@/components/chat/_components/message-list';
const chatChildComponents = {
  userList: UserListComponent,
  messageList: MessageListComponent
};
export default chatChildComponents;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_components/index.ts